export const agroPeasantModel = {
    label: 'Paysan (Agroforesterie)',
    tableName: 'peasants',
    properties: [
        {
            label: 'Nom',
            id: 'firstname',
            type: 'text',
            example: 'RAKOTO',
            required: true
        },
        {
            label: 'Prénom',
            id: 'lastname',
            type: 'text',
            example: 'Jean Claude',
            required: true
        },
        {
            label: 'Genre',
            id: 'genre',
            type: 'text',
            example: 'Masculin',
            required: true
        },
        {
            label: 'Téléphone',
            id: 'phone',
            type: 'text',
            example: '032 11 222 33',
            required: true
        },
        {
            label: 'Date de naissance',
            id: 'dob',
            type: 'date',
            example: 'JJ/MM/AAAA',
            required: true
        },
        {
            label: 'Début de collaboration',
            id: 'member_since',
            type: 'date',
            example: 'JJ/MM/AAAA',
            required: true
        },
        {
            label: 'Statut matrimonial',
            id: 'martial_status',
            type: 'text',
            example: 'Marié',
            required: true
        },
        {
            label: 'Statut paysan',
            id: 'status',
            type: 'text',
            example: 'Propriétaire',
            required: true
        },
        {
            label: 'Lien avec le propriétaire',
            id: 'proprietary_link',
            type: 'text',
            example: 'Lui-même',
            required: true
        },
        {
            label: 'Activité',
            id: 'activity',
            type: 'text',
            example: 'Agriculteur',
            required: true
        },
        {
            label: 'Raison de reboisement',
            id: 'reforestation_reason',
            type: 'text',
            example: 'Protection des sols',
            required: true
        },
        {
            label: 'Adresse',
            id: 'address',
            type: 'text',
            example: 'Lot IV 12 Antsiranana',
            required: true
        },
        {
            label: 'Groupe',
            id: 'agroGroups',
            isForeignKey: true,
            column_name: 'name',
            table_column: 'group_id',
            type: 'text',
            example: 'AGRO-DIANA-001',
            required: true
        }
    ]
}
